/**
 * Driver Billing Account DTO
 * Represents a billing account for a driver
 */
export class DriverBillingAccountDto {
  id: number;
  fortnight_earnings: number;
  state: boolean;
  created_date: string;
  modified_date: string;
  deleted_date: string | null;
  iban: string;
  iva: string;
  irpf: string;
  bic: string;
  is_favourite: boolean;
  business_name: string;
  driver: number;

  constructor(data: any = {}) {
    this.id = data.id || 0;
    this.fortnight_earnings = data.fortnight_earnings || 0;
    this.state = data.state ?? true;
    this.created_date = data.created_date || '';
    this.modified_date = data.modified_date || '';
    this.deleted_date = data.deleted_date || null;
    this.iban = data.iban || '';
    this.iva = data.iva || '';
    this.irpf = data.irpf || '';
    this.bic = data.bic || '';
    this.is_favourite = data.is_favourite ?? false;
    this.business_name = data.business_name || '';
    this.driver = data.driver || 0;
  }

  static fromJson(json: any): DriverBillingAccountDto {
    return new DriverBillingAccountDto(json);
  }

  toJson(): any {
    return {
      id: this.id,
      fortnight_earnings: this.fortnight_earnings,
      state: this.state,
      created_date: this.created_date,
      modified_date: this.modified_date,
      deleted_date: this.deleted_date,
      iban: this.iban,
      iva: this.iva,
      irpf: this.irpf,
      bic: this.bic,
      is_favourite: this.is_favourite,
      business_name: this.business_name,
      driver: this.driver
    };
  }
}

/**
 * CREATE DRIVER BILLING ACCOUNT REQUEST DTO
 * Represents the data needed to create a driver billing account
 */
export interface CreateDriverBillingAccountRequest {
  iban: string;
  bic: string;
  irpf: string;
  iva?: string;
  business_name?: string;
  is_favourite?: boolean;
  driver: number;
}

/**
 * UPDATE DRIVER BILLING ACCOUNT REQUEST DTO
 * Represents the data needed to update a driver billing account
 * IMPORTANTE: El campo driver es REQUERIDO por el API según la documentación
 */
export interface UpdateDriverBillingAccountRequest {
  iban?: string;
  bic?: string;
  irpf?: string;
  iva?: string;
  business_name?: string;
  is_favourite?: boolean;
  driver: number; // REQUERIDO para el PUT
}

/**
 * Paginated response for driver billing accounts
 */
export interface PaginatedDriverBillingAccountResponse {
  count: number;
  total_pages: number;
  next: string | null;
  previous: string | null;
  results: DriverBillingAccountDto[];
}
